// Who may remove a recorded payment. Mirrors modules/q2c/invoice-service.js deletePayment so the
// payment list shows Remove only where the API would delete it: the API answers 403 unless the
// person recorded it (created_by, compared lower-cased) or is an admin, and 409 on a void invoice.
// `me` is the signed-in user, { email, admin }, from src/lib/taskAccess.js myEmail() and amAdmin(),
// as the task and shipment pages decide their edit controls. Known limits, as for those pages: the
// token's email is the record email at sign-in, while the server compares the current one (they
// differ only if a user's email changes while a token is still valid); the route also needs write
// on 'invoices', which no control on the invoice page checks. A refused delete still shows its error.
export function canRemovePayment(payment, invoice, me) {
  if (!payment || !invoice || invoice.status === 'void') return false;
  if (me?.admin === true) return true;
  const email = String(me?.email || '').toLowerCase();
  return email !== '' && String(payment.created_by || '').toLowerCase() === email;
}
